import gsap from "gsap";

import { useEffect } from "react";
import WhyCourse from "../WhyCourse";



const HomeHero = () => {
  useEffect(() => {
    const parallaxIt = () => {
      const target = document.querySelectorAll(".js-mouse-move-container");

      target.forEach((container) => {
        const targets = container.querySelectorAll(".js-mouse-move");

        targets.forEach((el) => {
          const movement = el.getAttribute("data-move");

          document.addEventListener("mousemove", (e) => {
            const relX = e.pageX - container.offsetLeft;
            const relY = e.pageY - container.offsetTop;

            gsap.to(el, {
              x:
                ((relX - container.offsetWidth / 2) / container.offsetWidth) *
                Number(movement),
              y:
                ((relY - container.offsetHeight / 2) / container.offsetHeight) *
                Number(movement),
              duration: 0.2,
            });
          });
        });
      });
    };

    parallaxIt();
  }, []);


  // const navigateToVolumes = (params) => {
  //   if (!loggedIn) {
  //     navigate("/login?redirect_to=/volumes/GVK1");
  //     return;
  //   }
  //   navigate("/volumes/GVK1");
  // };


  return (
    <>
      <section className="masthead -type-1 js-mouse-move-container" style={{
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100vh'
      }}>
        <div className="masthead__bg" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1
        }}>
          {/* <img src={"/assets/global/achievements_banner.svg"} alt="image" style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: isDesktop ? 'right top' : 'top',
            //filter: 'brightness(1.2) contrast(1.3) saturate(1.2)'
          }} /> */}
        </div>

        <div className="container" style={{
          position: 'relative',
          zIndex: 2
        }}>
          <div className="row y-gap-30 justify-content-center items-end">
            <div className="col-12">
              <WhyCourse></WhyCourse>
              {/* <div
                // className="card col-lg-3 col-sm-12 mb-40 p-2 pointer"
                onClick={() => {
                  navigateToVolumes();
                }}
              >
                <img
                  className="card-img-top"
                  style={{ height: "100%" }}
                  src="../assets/global/volumes_banner.svg"
                  alt="Card image cap"
                />
                <div className="card-body">
                  <p className="card-text">
                    Watch 5 Free Classes Now!
                    <br></br>
                    Covers Entire Pharmacology Syllabus
                    <br></br>
                    Designed for RRB & All State Pharmacist exams
                  </p>
                </div>
              </div> */}
            </div>
            {/* <div
              className="col-xl-6 col-lg-6"
              data-aos="fade-up"
              data-aos-delay="700"
            >
              <div className="masthead-image">
                <div className="masthead-image__el1">
                  <img
                    className="js-mouse-move"
                    data-move="40"
                    style={{ objectFit: "cover" }}
                    src={"/assets/img/masthead/1.png"}
                    alt="image"
                  />
                  <div
                    data-move="30"
                    className="lg:d-none img-el -w-250 px-20 py-20 d-flex items-center bg-white rounded-8 js-mouse-move"
                  >
                    <div className="size-50 d-flex justify-center items-center bg-red-2 rounded-full">
                      <img src={"/assets/img/masthead/1.svg"} alt="icon" />
                    </div>
                    <div className="ml-20">
                      <div className="text-orange-1 text-16 fw-500 lh-1">
                        3.000 +
                      </div>
                      <div className="mt-3">Free Courses</div>
                    </div>
                  </div>
                </div>

                <div className="masthead-image__el2">
                  <img
                    className="js-mouse-move"
                    data-move="70"
                    src={"/assets/img/masthead/2.png"}
                    style={{ objectFit: "cover" }}
                    alt="image"
                  />
                  <div
                    data-move="60"
                    className="lg:d-none img-el -w-260 px-20 py-20 d-flex items-center bg-white rounded-8 js-mouse-move"
                  >
                    <img src={"/assets/img/masthead/4.png"} alt="icon" />
                    <div className="ml-20">
                      <div className="text-dark-1 text-16 fw-500 lh-1">
                        Ali Tufan
                      </div>
                      <div className="mt-3">UX/UI Designer</div>
                      <div className="d-flex x-gap-5 mt-3">
                        {starts.map((start, index) => (
                          <div key={index}>
                            <div className={start}></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="masthead-image__el3">
                  <img
                    className="js-mouse-move"
                    data-move="40"
                    src={"/assets/img/masthead/3.png"}
                    style={{ objectFit: "cover" }}
                    alt="image"
                  />
                  <div
                    data-move="30"
                    className="shadow-4 img-el -w-260 px-30 py-20 d-flex items-center bg-white rounded-8 js-mouse-move"
                  >
                    <div className="img-el__side">
                      <div className="size-50 d-flex justify-center items-center bg-purple-1 rounded-full">
                        <img
                          style={{ objectFit: "cover" }}
                          src={"/assets/img/masthead/2.svg"}
                          alt="icon"
                        />
                      </div>
                    </div>
                    <div className="">
                      <div className="text-purple-1 text-16 fw-500 lh-1">
                        Congrats!
                      </div>
                      <div className="mt-3">Your Admission Completed</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* animated shape start */}
      
        {/* animated shape end */}
      </section>
    </>
  );
};

export default HomeHero;
